import { useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import PortfolioSection from './components/PortfolioSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import SeriesSection from '../products/components/SeriesSection';
import JsonLd from '../../components/base/JsonLd';

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://example.com';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'ONOPTO 普像光学',
    url: SITE_URL,
    description:
      'Precision optical technology company specializing in mercury-xenon lamps, heating lamps, and UV lamps for semiconductor, medical imaging, and industrial applications. Founded 2004, serving 30+ countries.',
    foundingDate: '2004',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'No. 88 Guanghua Rd, Pudong New Area',
      addressLocality: 'Shanghai',
      addressCountry: 'CN',
      postalCode: '200120',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-21-6888-8888',
      contactType: 'customer service',
      email: 'info@onopto.com',
    },
    sameAs: [SITE_URL],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'ONOPTO 普像光学',
    url: SITE_URL,
    description:
      'Official website of ONOPTO (普像光学) — precision optical lamp solutions for semiconductor manufacturing, machine vision, and advanced illumination.',
    publisher: {
      '@type': 'Organization',
      name: 'ONOPTO 普像光学',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${SITE_URL}/`,
    url: `${SITE_URL}/`,
    name: 'ONOPTO 普像光学 | Precision Optical Technology Solutions',
    description:
      'ONOPTO (普像光学) delivers cutting-edge precision optical solutions including mercury-xenon lamps, heating lamps, and UV lamps. 20+ years of optical expertise serving 30+ countries.',
    isPartOf: { '@id': SITE_URL },
    about: {
      '@type': 'Organization',
      name: 'ONOPTO 普像光学',
    },
    inLanguage: 'en',
    dateModified: '2026-03-31',
  },
];

export default function HomePage() {
  useEffect(() => {
    if (sessionStorage.getItem('scrollToContact') === '1') {
      sessionStorage.removeItem('scrollToContact');
      const el = document.getElementById('contact');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, []);

  return (
    <div className="min-h-screen font-sans antialiased">
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <PortfolioSection />
        <div id="products">
          <SeriesSection />
        </div>
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
